import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const withRouter = Component => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const history = {
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      goBack: () => navigate(-1),
      back: () => navigate(-1),
      go: delta => navigate(delta),
      location,
    };

    return <Component {...props} history={history} location={location} match={{ params }} />;
  }

  ComponentWithRouterProp.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;

  return ComponentWithRouterProp;
};

export default withRouter;
